import { useState } from "react";

import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "react-bootstrap/Card";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

/**
 * CSV lead-source picker for LeadsStep1: file input plus a removable
 * "selected file" card. The chosen file only unlocks the Next button; it is
 * not part of the step-1 payload, so the File object can live here.
 */
const CsvLeadSourceSection = ({ onFileSelected }) => {
    const language = useSelector((state) => state.languagesState.languages);
    const [file, setFile] = useState("");

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        onFileSelected();
    };

    const confirmFileRemove = () => {
        Swal.fire({
            cancelButtonColor: "#dc3545",
            cancelButtonText: language?.delete_swal_modal?.no ?? "No",
            confirmButtonColor: "#28a745",
            confirmButtonText: language?.delete_swal_modal?.yes ?? "Yes",
            icon: "warning",
            showCancelButton: true,
            title:
                language?.delete_swal_modal?.are_you_sure ?? "Are You Sure ?",
        }).then((sweetAlertResult) => sweetAlertResult.value && setFile(""));
    };

    return (
        <div className="my-3">
            {file === "" ? (
                <Card>
                    <Card.Body className="row py-2 px-4">
                        <input
                            type={"file"}
                            accept={".csv"}
                            onChange={handleFileChange}
                        />
                    </Card.Body>
                </Card>
            ) : (
                <Card>
                    <Card.Body className="row py-2 g-2">
                        <div className="col-12 col-sm-8 d-flex align-items-center text-break">
                            {file.name}
                        </div>
                        <div className="col-12 col-sm-4 d-flex justify-content-sm-end justify-content-start">
                            <div onClick={confirmFileRemove}>
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};

export default CsvLeadSourceSection;
